/**
 *
 * Component: Header
 * Date: 22/1/2021
 *
 */

import React from 'react';

import Auth from 'auth0-react';
import { useHistory, useLocation } from 'react-router-dom';
import Tag from 'components/common/Tag';
import Icon from 'components/common/Icon/index';
// import { useIntercom } from 'react-use-intercom';
import _ from 'lodash';
import Tooltip from 'components/common/Tooltip';
import mixpanel from 'utils/mixpanel';
import Button from 'components/common/Button';
import styles from './style.module.css';

const { logout } = new Auth();

function Header() {
  const { pathname } = useLocation();
  // const { hardShutdown } = useIntercom();
  const userEmail = localStorage.getItem('userEmail');
  const history = useHistory() as any;

  const getHeaderTitle = (path: string) => {
    switch (path) {
      case '/insights':
        return 'Insights View';
      case '/live':
        return 'Live View';
      case '/visuals':
        return 'Visuals';
      case '/configs/visualsConfiguration':
        return 'Visual Configuration';
      default:
        if (path && _.isString(path) && path.includes('/visuals/')) {
          const visualTitle = path.substring(
            path.lastIndexOf('/') + 1,
            path.length,
          );
          return `Visuals (${visualTitle})`;
        }
        return '';
    }
  };

  const handleLogout = () => {
    logout();
    mixpanel('Agent Logout', 'Header Logout', { userId: `${userEmail}` });
    // for intercom if needed to add later.
    // hardShutdown();
  };

  const goBackFunction = () => {
    history.goBack();
  };

  const getBackButton = (path: string) => {
    const route = path.split('/') || [];
    const paramLength = route.length;
    if (paramLength < 3 || !path.includes('/visuals/'))
      return <div className={styles.vacantSpace} />;
    return (
      <div className={styles.headerButton}>
        <Button
          className="header-back"
          icon="arrowLeft"
          type="circle"
          iconSize={10}
          iconColor="white"
          width="22px"
          height="22px"
          onClick={() => goBackFunction()}
        />
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <span className={styles.headerTitle}>
        {getBackButton(pathname)}
        {getHeaderTitle(pathname)}
      </span>
      <section style={{ width: '100%' }}>
        <div style={{ float: 'right' }}>
          <Tag text={userEmail} color="#dee3e7" style={{ color: '#52616b' }} />
          <Tooltip title="logout">
            <span className={styles.headerLogout} onClick={handleLogout}>
              <Icon type="logout" size={16} />
            </span>
          </Tooltip>
        </div>
      </section>
    </div>
  );
}

export default Header;
